// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3K_uk","footer":"ModalError_footer__2ss6e"};